module.exports = __webpack_public_path__ + "media/xx.42d9d35b.mp4";